var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 0.75H15C16.3672 0.75 17.5 1.88281 17.5 3.25V15.75C17.5 17.1562 16.3672 18.25 15 18.25H2.5C1.09375 18.25 0 17.1562 0 15.75V3.25C0 1.88281 1.09375 0.75 2.5 0.75ZM13.1641 7.66406H13.125C13.5156 7.3125 13.5156 6.72656 13.125 6.33594C12.7734 5.98438 12.1875 5.98438 11.8359 6.33594L7.5 10.7109L5.66406 8.875C5.27344 8.48438 4.6875 8.48438 4.33594 8.875C3.94531 9.22656 3.94531 9.8125 4.33594 10.1641L6.83594 12.6641C7.1875 13.0547 7.77344 13.0547 8.16406 12.6641L13.1641 7.66406Z",
    fill: "#C1F553"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelected);
export default __webpack_public_path__ + "static/media/selected.489936b1899f725a899f278d1390f1ea.svg";
export { ForwardRef as ReactComponent };